import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useAppStore } from '@/app/store'
import { cn } from '@/utils/cn'

import { useTranslation } from 'react-i18next'

export function Layout() {
  const { sidebarOpen, setSidebarOpen } = useAppStore()
  const { i18n } = useTranslation()
  const isRtl = i18n.language?.startsWith('ar')

  return (
    <div className="min-h-screen bg-background">
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 md:hidden"
          onClick={() => setSidebarOpen(false)}
          aria-hidden
        />
      )}

      <div
        className={cn(
          'fixed inset-y-0 start-0 z-40 flex flex-col transition-transform duration-300 md:translate-x-0',
          sidebarOpen
            ? 'translate-x-0'
            : (isRtl ? 'translate-x-full md:translate-x-0' : '-translate-x-full md:translate-x-0')
        )}
      >
        <Sidebar />
      </div>

      <div
        className={cn(
          'flex flex-col min-h-screen transition-all duration-200',
          sidebarOpen ? 'md:ms-60' : 'md:ms-16'
        )}
      >
        <Header />
        <main className="flex-1 p-4 sm:p-6 min-h-[calc(100vh-5.5rem)]">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
